<template>
    <LayoutSub className="pb-0 pos">
        <div class="tab_menu">
            <button type="button" @click="activeContent = 'easypos'" :class="{ selected: activeContent === 'easypos' }" :aria-pressed="activeContent === 'easypos'">EasyPOS</button>
            <button type="button" @click="activeContent = 'air'" :class="{ selected: activeContent === 'air' }" :aria-pressed="activeContent === 'air'">EasyPOS Air</button>
        </div>
        <template v-if="activeContent === 'easypos'">
            <SubpageTitleContainer class="pt-0" title="EasyPOS"
                subText="업계 최초로 원천기술을 확보한 이지포스는 압도적인 기술력과 다양하고 풍부한 프로젝트 수행 노하우를 바탕으로 일반 가맹점부터 대형 프랜차이즈까지 안정적인 서비스를 제공하고 있습니다.">
                <RedLineButton :type="`inbound`" :text="`부가서비스`" />
            </SubpageTitleContainer>
            <SubSection class="pt-0">
                <RedTitleRow title="출시">
                    <li>
                        <p>’07. Window용 POS, ’16. 업계 최초 ‘Android 기반 POS’ 출시</p>
                    </li>
                    <li>
                        <p>’16. 국내 최초 POS와 매출통합관리 기능을 구현한 ‘KIOSK’ 출시</p>
                    </li>
                </RedTitleRow>
            </SubSection>
            <SubSection type="wide">
                <SubTitle3 listStyle="dot">특징</SubTitle3>
                <div class="table-2grid">
                    <TableRow_2grid title="범용성 높은 프로그램" content="F&B, 유통, 선/후불제 등 모든 업종에서 서비스를 사용할 수 있습니다."
                        src="pos_icon_1.png" />
                    <TableRow_2grid title="다양한 어플리케이션과의 확장성 보장"
                        content="메인 포스와 각종 부가 솔루션을 OS(윈도우, 안드로이드) 와 상관 없이 모든 구간 연동이 가능합니다." src="pos_icon_2.png" />
                    <TableRow_2grid title="가맹점 커스터마이징" content="자체 개발 POS 프로그램으로 가맹점 요구사항에 맞춘 프로그램 수정과 특수버전을 제공합니다."
                        src="pos_icon_3.png" />
                    <TableRow_2grid title="외부업체와의 다양한 서비스 연동" content="포인트/상품권 등 원하는 외부 업체와의 다양한 서비스 연동을 지원합니다."
                        src="pos_icon_4.png" />
                    <TableRow_2grid title="모든 결제수단 지원" content="새로운 결제 수단을 가장 빠르게 사용할 수 있습니다." src="pos_icon_5.png" />
                </div>
            </SubSection>
            <SubSection>
                <!-- subText: api data -->
                <StickyContainer title="주요 기능" secondTitle="" subText="" :leftItems="posLeftItems" :rightItems="posRightItems">
                </StickyContainer>
            </SubSection>
            <SubSection type="wide">
                <SubTitle3 listStyle="dot">부가서비스</SubTitle3>
                <div class="table-2grid">
                    <TableRow_2grid :title="`MATE CONNECT (푸드테크 배달 연동 POS)`"
                        :list="['배달중개 플랫폼 푸드테크와의 API 정식 연동으로 주문 누락없이 안정적으로 서비스 합니다.', '배달 프로그램 별도 설치 없이 EasyPOS에서 한 번에 처리가 가능합니다', '주문접수, 배달기사 호출, 통합 매출 조회를 모바일에서도 사용할 수 있습니다.']"
                        :src="`pos_icon_6.png`" />
                    <TableRow_2grid :title="`네이버 주문/예약`"
                        :list="['네이버주문과 EasyPOS와의 연동으로 테이블 내 QR 결제와 실시간 주문 알림을 통해 효율화된 매장 운영을 지원합니다.', '예약과 동시에 EasyPOS에서 조회가 가능하며 예약 진행 현황 등 예약 관리가 용이합니다.']"
                        :src="`pos_icon_7.png`" />
                </div>
            </SubSection>
        </template>
        <EasyPOSAir v-else />
    </LayoutSub>
</template>

<script>
import LayoutSub from '@/layouts/LayoutSub.vue';
import SubSection from '@/components/SubSection.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import RedTitleRow from '@/components/RedTitleRow.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import TableRow_2grid from '@/components/TableRow_2grid.vue';
import StickyContainer from '@/components/StickyContainer.vue';
// import RedLineButton from '@/components/RedLineButton.vue';
import EasyPOSAir from './EasyPOSAir.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
        SubpageTitleContainer,
        RedTitleRow,
        SubTitle3,
        TableRow_2grid,
        StickyContainer,
        // RedLineButton
        EasyPOSAir,
    },
    data() {
        return {
            activeContent: 'easypos',
            posLeftItems: [
                { text: "기본 기능", active: true },
                { text: "포스 클라이언트", active: false },
                { text: "포스-ASP연동", active: false },
                { text: "지원", active: false },
                { text: "카카오알림톡", active: false },
                { text: "장치 모니터링", active: false },
            ],
            posRightItems: [
                {
                    img: require("@/assets/pos_img_1.png"),
                    title: "기본 기능",
                    description: "매장별 맞춤형 화면을 구성(터치키/기능키) 가능",
                },
                {
                    img: require("@/assets/pos_img_2.png"),
                    title: "포스 클라이언트",
                    list: [
                        "영업 일자별로 현금/카드/상품권 등 결제 수단별 매출 확인",
                        "영업시간별, 매출건별로 내역 확인 및 영수증 출력",
                        "간편한 조작으로 간이영수증 인쇄 가능",
                        "고객 관리 기능 제공(신규 고객등록 및 기존 고객 정보 조회)",
                    ]
                },
                {
                    img: require("@/assets/pos_img_3.png"),
                    title: "포스-ASP연동",
                    list: [
                        "POS 웹 시스템의 다양한 통계자료를 POS에서 확인 가능",
                        "Web ASP에서 매출분석, 재고/수주관리, 고객 관리 기능",
                        "Web ASP에서의 변경 사항에 대한 실시간 적용(업데이트)",
                        "직원 출/퇴근 관리를 위한 근태등록 기능 제공(ASP 연동)",
                    ]
                },
                {
                    img: require("@/assets/pos_img_4.png"),
                    title: "지원",
                    description:
                        "POS 문제 발생 시 EasyPOS 콜센터를 통한 원격 지원",
                },
                {
                    img: require("@/assets/pos_img_5.png"),
                    title: "카카오알림톡",
                    list: [
                        "POS, KIOSK를 통해 결제 시, 고객 카카오톡을 통해 주문 접수 및 조리 완료 내역 호출 알림톡 발송 (건당 비용 발생)",
                        "고객 좌석과의 거리가 먼 대형 매장(창고형 카페 등)에서 이용할 수 있음",
                        "고객 주문서 대체로 용지 절감실현, 친환경 매장 구성 지원",
                        "포스, 키오스크를 포함한 모든 이지포스솔루션 전체를 연결하여 사용 가능",
                    ]
                },
                {
                    img: require("@/assets/pos_img_6.png"),
                    title: "장치 모니터링",
                    list: [
                        "키오스크, 테이블오더 등 포스와 연결되어있는 메인솔루션 운용 장비 - 원격 제어 가능",
                        "마감 및 개점 / 메시지 전송 등",
                    ]
                }
            ]
        }
    }
};
</script>
<style lang="scss" scoped>
.tab_menu {
    width: 90%;
    max-width: 1540px;
    margin-bottom: 70px;

    @media screen and (max-width: 768px) {
        margin: 50px auto;
    }
}
</style>
